export const drawerWidth = 330;

export const LISTA_HORAS = [
  { hora: "00:00" },
  { hora: "00:15" },
  { hora: "00:30" },
  { hora: "00:45" },
  { hora: "01:00" },
  { hora: "01:15" },
  { hora: "01:30" },
  { hora: "01:45" },
  { hora: "02:00" },
  { hora: "02:15" },
  { hora: "02:30" },
  { hora: "02:45" },
  { hora: "03:00" },
  { hora: "03:15" },
  { hora: "03:30" },
  { hora: "03:45" },
  { hora: "04:00" },
  { hora: "04:15" },
  { hora: "04:30" },
  { hora: "04:45" },
  { hora: "05:00" },
  { hora: "05:15" },
  { hora: "05:30" },
  { hora: "05:45" },
  { hora: "06:00" },
  { hora: "06:15" },
  { hora: "06:30" },
  { hora: "06:45" },
  { hora: "07:00" },
  { hora: "07:15" },
  { hora: "07:30" },
  { hora: "07:45" },
  { hora: "08:00" },
  { hora: "08:15" },
  { hora: "08:30" },
  { hora: "08:45" },
  { hora: "09:00" },
  { hora: "09:15" },
  { hora: "09:30" },
  { hora: "09:45" },
  { hora: "10:00" },
  { hora: "10:15" },
  { hora: "10:30" },
  { hora: "10:45" },
  { hora: "11:00" },
  { hora: "11:15" },
  { hora: "11:30" },
  { hora: "11:45" },
  { hora: "12:00" },
  { hora: "12:15" },
  { hora: "12:30" },
  { hora: "12:45" },
  { hora: "13:00" },
  { hora: "13:15" },
  { hora: "13:30" },
  { hora: "13:45" },
  { hora: "14:00" },
  { hora: "14:15" },
  { hora: "14:30" },
  { hora: "14:45" },
  { hora: "15:00" },
  { hora: "15:15" },
  { hora: "15:30" },
  { hora: "15:45" },
  { hora: "16:00" },
  { hora: "16:15" },
  { hora: "16:30" },
  { hora: "16:45" },
  { hora: "17:00" },
  { hora: "17:15" },
  { hora: "17:30" },
  { hora: "17:45" },
  { hora: "18:00" },
  { hora: "18:15" },
  { hora: "18:30" },
  { hora: "18:45" },
  { hora: "19:00" },
  { hora: "19:15" },
  { hora: "19:30" },
  { hora: "19:45" },
  { hora: "20:00" },
  { hora: "20:15" },
  { hora: "20:30" },
  { hora: "20:45" },
  { hora: "21:00" },
  { hora: "21:15" },
  { hora: "21:30" },
  { hora: "21:45" },
  { hora: "22:00" },
  { hora: "22:15" },
  { hora: "22:30" },
  { hora: "22:45" },
  { hora: "23:00" },
  { hora: "23:15" },
  { hora: "23:30" },
  { hora: "23:45" },
];

export const PRIORIDADE_AGENDAMENTO_BAIXA = 0;
export const PRIORIDADE_AGENDAMENTO_MEDIA = 1;
export const PRIORIDADE_AGENDAMENTO_ALTA = 2;

export const LISTA_PRIORIDADE_AGENDAMENTO = [
  { codigo: PRIORIDADE_AGENDAMENTO_BAIXA, descricao: "Baixa" },
  { codigo: PRIORIDADE_AGENDAMENTO_MEDIA, descricao: "Média" },
  { codigo: PRIORIDADE_AGENDAMENTO_ALTA, descricao: "Alta" },
];

export const MENSAGEM_USUARIO_SEM_MAIL_PARA_RECUPERAR_SENHA =
  "Usuário não possui e-mail cadastrado! Entre em contato com a equipe de suporte para recuperação de sua senha";

export const MENSAGEM_CODIGO_VERIFICACAO_RECUPERACAO_SENHA_INVALIDO =
  "Código de verificação inválido!";

export const MENSAGEM_TEMPO_RECUPERACAO_SENHA_EXCEDIDO =
  "O código de recuperação expirou. Solicite um novo para redefinir sua senha.";

export const MENSAGEM_CAMPO_OBRIGATORIO = "Campo obrigatório não preenchido!";
